import script from "./AppMain2.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain2.vue?vue&type=script&setup=true&lang=js"

import "./AppMain2.vue?vue&type=style&index=0&id=e9ce41f0&lang=scss&scoped=true"
import "./AppMain2.vue?vue&type=style&index=1&id=e9ce41f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9ce41f0"]])

export default __exports__